require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2012-03-13-retaliatory-only-patents.json") })
        }
      }, "path---articles-2012-03-13-retaliatory-only-patents");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2012-03-13-retaliatory-only-patents!./.cache/json/articles-2012-03-13-retaliatory-only-patents.json
// module id = 619
// module chunks = 231608221292675